export default text => {
  return text && text.split('\n').map(p => `<p>${p}</p>`).join('')
}



// WEBPACK FOOTER //
// ./src/filters/textToWeb.js